import { IntlFormatters } from 'react-intl';

import { ServiceMode } from 'state/service-mode/types';

import { DELIVERY_SERVICE_MODES } from './service-mode';

export enum ServiceModeCategory {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

/**
 * @name determineServiceModeCategory
 * @description gives a category to the provided SM
 *     need this bc pickup has multiple
 *     SM values that fall into one of the categories
 */
export const determineServiceModeCategory = (serviceMode: ServiceMode) => {
  let smType = ServiceModeCategory.PICKUP;
  if (DELIVERY_SERVICE_MODES.includes(serviceMode)) {
    smType = ServiceModeCategory.DELIVERY;
  }
  return smType;
};

export const getLocalizedServiceModeCategory = (
  serviceMode: ServiceMode,
  formatMessage: IntlFormatters['formatMessage']
): string => {
  const serviceModeCategory = determineServiceModeCategory(serviceMode);
  switch (serviceModeCategory) {
    case ServiceModeCategory.DELIVERY:
      return formatMessage({ id: 'delivery' });
    case ServiceModeCategory.PICKUP:
      return formatMessage({ id: 'pickUp' });
    default:
      return '';
  }
};
